import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {SEARCH_FILTERS} from '@/src/app/constants/search';
import fetchAvailablePositions from '@/src/profile/common/utils/fetchAvaliablePositions';
import FilterRow from '@/src/Search/components/FilterRow';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {CheckboxCommon, SimpleCollapse, Text} from '@/src/ui';

interface JobPositionsFilterProps {
  onChangeHandler: (...args: any) => any;
}

const JobPositionsFilter = ({onChangeHandler}: JobPositionsFilterProps) => {
  const {locale, query} = useRouter();
  const [positionsList, setPositionsList] = useState(null);

  useEffect(() => {
    const fetchPositionsList = async () => {
      const {responseBody, status} = await fetchAvailablePositions();

      if (status === RESPONSE_STATUSES.SUCCESS) {
        setPositionsList(responseBody.data);
      }
    };

    if (positionsList === null) {
      fetchPositionsList();
    }
  }, [positionsList]);

  if (positionsList === null) {
    return null;
  }

  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'profile.job-positions'} />
        </Text>
      }
    >
      {positionsList.map((positionItem) => {
        return (
          <FilterRow key={positionItem.id}>
            {/* @ts-ignore */}
            <CheckboxCommon
              id={positionItem.id}
              name={positionItem.id}
              label={positionItem[`name_${locale}`]}
              data-filter-name={SEARCH_FILTERS.PREFERABLE_POSITION}
              data-value={positionItem.id}
              checked={
                !!query[SEARCH_FILTERS.PREFERABLE_POSITION] &&
                // @ts-ignore
                JSON.parse([
                  query[SEARCH_FILTERS.PREFERABLE_POSITION],
                ]).includes(String(positionItem.id))
              }
              onChange={onChangeHandler}
              isSemibold
            />
          </FilterRow>
        );
      })}
    </SimpleCollapse>
  );
};

export default JobPositionsFilter;
